import React from 'react'
import Layout from '../../Layout/Layout'
import research1 from "../../images/research1.PNG"
import research2 from "../../images/research2.PNG"
import research3 from "../../images/research3.PNG"

const Research_to_commercialization = () => {
  return (
           <Layout>
        <div className='uk-container'>
            <div>
                <h2 className='light uk-text-bold uk-margin-xlarge-top'> Research to Commercialization Efforts</h2>
                
                <h3 className='light uk-text-bold '>Research to Commercialization Workshop</h3>
                
                </div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The Research-to-Commercialization (R2C) Workshop 
                        was a pivotal initiative designed to tackle Nigeria's low rate of
                         research commercialization, where only 2% of research output 
                         typically reaches the market. The program was a joint effort
                          led by the Impact Investors Foundation (IIF) through the 
                          Nigerian Impact Investing Research and Industry Collaborative
                           (NIIRIC), with Moolu Venture Lab serving as the key Facilitator
                            and technical lead. This strategic collaboration aimed to build
                             a robust framework that successfully transitions groundbreaking 
                             academic and institutional research into viable commercial products and services.
</p>

                <p className='light'>The workshop delivered actionable outcomes through four intensive
                     core sessions. The first session covered the Foundational Understanding of
                      commercialization and barriers, while the second focused on Intellectual
                       Property (IP), design thinking, and business models using the Lean Canvas. 
                       The final two sessions covered Investment Readiness & Pitching to articulate
                        innovations to investors and the development of a structured Commercialization 
                        Roadmap and next steps.</p>

               </div>

                <div className='uk-width-1-2@s'>
                    <img src={ research1} />
               </div>
            </div>




               <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                       <img src={ research2} /> 
               </div>

                <div className='uk-width-1-2@s'>

                <p className='light'>The implementation, supported by UKAid/RISA 
                    (Research and Innovation Systems for Africa), emphasized
                     localization with all training materials and case studies
                      reflecting Nigerian market realities. This focus on practical,
                       context-specific application ensured high engagement, 
                       evidenced by a remarkable 95% participant retention in 
                       the post-event Community of Practice. The R2C Workshop 
                       and its resulting toolkit reaffirm the commitment to 
                       strengthening the Nigerian innovation ecosystem and
                        unlocking the nation's economic potential.
</p>

               


                  
               </div>
            </div>


            <div className='uk-grid'>
              <div className='uk-width-3-4@s'>
                <img src={ research3} /> 
              </div>

               <div className='uk-width-1-4@s'>

              </div>
            </div>
        </div>
        </Layout>
  )
}

export default Research_to_commercialization